import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		opacity: 0.75;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-size: 16px;
		line-height: 18px;
		color: rgba(255, 255, 255, 0.75);
	}
`;

export { StyledContainer };
